import React, { Component } from 'react';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    applicant?: number;
    firstName: string;
    smoker?: string;
    updateLead(props: any): void;
    consent: boolean; 
    applicationType: string;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    smoker?: string;
    partnerSmoker?: boolean;
    consent?: boolean;
}

export class SmokerStatus extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {
            hasError: false, 
            smoker: this.props.smoker, 
        };
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    CaptureSmokingResponse(option:string){
        this.setState({smoker:option, hasError:false});
    }

    nextStep(smoker: string) {
    const errors: string[] = [];
    if(!smoker){
        errors.push('Please select a response Have you smoked, vaped or used any nicotine replacement products in the last 12 months?');        
    }

    if (!this.state.consent && (
        (this.props.applicationType === 'single' && this.props.applicant === 1) ||
        (this.props.applicationType === 'joint' && this.props.applicant === 2)
    )) {
        errors.push('Consent is required');
    }

    if (errors.length > 0) {
        this.setState({ hasError: true, errors });
        return;
    }
    if(smoker){
        if(this.props.applicant === 1) 
            this.props.updateLead({smoker: smoker}); 
        else
            this.props.updateLead({partnerSmoker: smoker}); 
            //this.props.nextStep()
    }
    this.setState({ hasError: false, errors: [] });
    this.props.nextStep()
}

    render() {
        const{smoker,hasError,errors}=this.state;
        return (
            <header className="App-header">
                <div className='wrapper'>
                    {/* <h1 className='l'>And {this.props.applicant === 1 ? 'finally' : 'your partner'}</h1> */}
                    <h1 className='l'>And finally,{(this.props.applicationType === 'joint' && this.props.applicant === 2)?' your partner':''}</h1>
                    <h2 className='l'>{this.props.applicant === 1 ? 'Have you' : 'Have they'} smoked, vaped or used any nicotine replacement<br />products in the <span className='doddltext'>last 12 months?</span></h2>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            {/* <div className='boxty small'onClick={() => this.nextStep('No')}> */}
                            <div className={`boxty small ${smoker === 'No' ? 'selected' : ''}`}onClick={() => this.CaptureSmokingResponse('No')}>
                                <div>
                                    <div><h2 className='btn'>No</h2></div>
                                </div>
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            {/* <div className='boxty small' onClick={() => this.nextStep('Yes')}> */}
                            <div className={`boxty small ${smoker === 'Yes' ? 'selected' : ''}`} onClick={() => this.CaptureSmokingResponse('Yes')}>
                                <div>
                                    <div><h2 className='btn'>Yes</h2></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    } */}

                    {((this.props.applicationType === 'single' && this.props.applicant === 1) || (this.props.applicationType === 'joint' && this.props.applicant === 2)) ?(
                        
                        <div className='row'>
                            <div className='d-column'>
                            <label htmlFor='consent'>We have sent our Terms of Business and Privacy Notice to your email</label> <br/> 
                            <input
                                id='consent' 
                                type='checkbox' 
                                name='consent'
                                checked={this.props.consent}
                                className={this.state.hasError && !this.state.consent ? "e" : ""}
                                onChange={(e) => { this.setState({consent: e.target.checked}); this.props.updateLead({consentGiven: e.target.checked}); }} />
                            <label htmlFor='consent'>I consent for doddl to process the information I provided, and to contact me in relation to my mortgage and associated insurances as per the <a href='https://doddl.ie/privacy-notice/' target='_blank'>doddl Privacy Notice</a> and <a href='https://doddl.ie/terms-conditions/' target='_blank'>Terms of Business</a></label>
                            </div>
                        </div>):null
                    }

                    {hasError &&
                        <ErrorBox errors={errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton customLabel={(this.props.applicationType === 'single' && this.props.applicant === 1) || (this.props.applicationType === 'joint' && this.props.applicant === 2)?'Finish':'Next'} onClick={() => this.nextStep(smoker)} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}
